import { makeStyles, withStyles } from '@material-ui/core/styles';
import { colors } from '../../../constants/colors/Colors';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
export const useStyles = makeStyles((theme) => ({
    createServiceUserContainer: {
        height: 193,
        backgroundColor: '#E6EDF3',
        borderRadius: 6,
        paddingBottom: 35,
        paddingTop: 35,
        paddingLeft: 40,
        paddingRight: 40,
        marginTop: 40,
        "@media (max-width: 700px)": {
            height: 'auto',
        },
    },
    createSrvceUserTxt: {
        color: colors.titleColor,
        fontSize: 16,
        fontWeight: '600',
        marginTop: 0,
    },
    inputLabel: {
        color: colors.titleColor,
        fontSize: 16,
        fontWeight: '400',
        marginTop: 20,
        marginBottom: 0,
    },
    inputAndBtnRow: {
        display: 'flex',
        marginTop: 10,
        width: '100%',
        alignItems: 'center',
        "@media (max-width: 700px)": {
            display: 'block'
        },
    },
    userNameInput: {
        borderRadius: 8,
        boxSizing: 'border-box',
        border: '1px solid #D4DDE4',
        backgroundColor: '#F4F6F8',
        width: 481,
        height: 49,
        padding: 14,
        "@media (max-width: 700px)": {
            width: '100%',
        },
    },
    addBtn: {
        borderRadius: 8,
        background: 'linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)',
        width: 181,
        height: 48,
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: '600',
        border: 'none',
        marginLeft: 10,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        "@media (max-width: 700px)": {
            width: '100%',
            marginTop: 20,
            marginLeft: 0,
        },
    },
    noteContainer: {
        width: '100%',
        border: `1px solid #00B9FF`,
        height: 'auto',
        borderRadius: 6,
        marginTop: 40,
        display: 'inline-flex',
        backgroundColor: 'rgba(3, 169, 244, 0.07)',
    },

    infoIconContainer: {
        width: 92,
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(3, 169, 244, 0.12)',
        borderRight: `1px solid #00B9FF`,
        borderTopLeftRadius: 6,
        borderBottomLeftRadius: 6,
    },
    noteTextContainer: {
        marginLeft: 30,
    },
    noteText: {
        fontWeight: '600',
        fontSize: 16,
        color: colors.titleColor,
        lineHeight: 1.2,
    },
    importantNote: {
        color: '#5B6773',
        fontSize: 16,
        fontWeight: '400',
    },
    srvcUserNameTxt: {
        color: colors.titleColor,
        fontSize: 20,
        marginTop: 40,
        fontWeight: '500',
        letterSpacing: '-0.0014em',
        marginBottom: 0,
    },
    inputWithIconContainer: {
        width: '100%',
        display: "inline-flex",
        alignItems: 'center',
        marginTop: 10,
    },
    searchInput: {
        height: 50,
        width: 482,
        backgroundColor: '#F4F6F8',
        borderRadius: 8,
        color: '#5B6773',
        border: '1px solid #D4DDE4',
        boxSizing: 'border-box',
        paddingLeft: 15,
        letterSpacing: '-0.1px',
        fontSize: 14,
        fontWeight: '400',
        fontStyle: 'normal',
        paddingRight: 60,
        "@media (max-width: 1500px)": {
            width: '80%'
        },
        "@media (max-width: 1200px)": {
            width: '100%',
        },
    },
    iconContainer: {
        backgroundColor: '#F4F6F8',
        width: 30,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        right: 33.5,
        height: 42,
        "@media (max-width: 1200px)": {
            position: 'absolute',
            right: 60,
        },
    },
    eventContainer: {
        borderRadius: 12,
        marginTop: 40,
    },
    table: {
        minWidth: 950,
        [theme.breakpoints.down('sm')]: {
            width: 1500,
        },
    },
    passwordInputAndCopyIconRow: {
        display: 'flex',
    },
    passwordInput: {
        width: 155,
        height: 29,
        borderRadius: '4px 0px 0px 4px',
        border: '1px solid #D4DDE4',
        backgroundColor: ' #F4F6F8',
        color: '#5B6773',
        letterSpacing: '-0.0014em',
        fontSize: 20,
        fontWeight: '500',
        paddingTop: 12,
        paddingLeft: 11,
        paddingRight: 10,
    },
    visiblePasswordInput: {
        width: 155,
        height: 29,
        borderRadius: '4px 0px 0px 4px',
        border: '1px solid #D4DDE4',
        backgroundColor: ' #F4F6F8',
        color: '#5B6773',
        letterSpacing: '-0.0014em',
        fontSize: 20,
        fontWeight: '500',
        paddingLeft: 11,
        paddingRight: 10,
    },
    eyeIconContainer: {
        borderRadius: '0px 6px 6px 0px',
        border: '1px solid #D4DDE4',
        backgroundColor: '#F4F6F8',
        width: 34,
        height: 29,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 12,
        cursor: 'pointer',
    },
    passwordVisibleEyeContainer: {
        borderRadius: '0px 6px 6px 0px',
        border: '1px solid #D4DDE4',
        backgroundColor: 'rgba(130, 78, 210, 0.16)',
        width: 34,
        height: 29,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 12,
        cursor: 'pointer',
    },
    copyIcon: {
        cursor: 'pointer',
    },
    certificateBtnsRow: {
        display: 'flex',
    },
    certificateBtn: {
        width: 173,
        height: 38,
        borderRadius: 6,
        border: '1px solid #D4DDE4',
        backgroundColor: "#F4F6F8",
        fontSize: 16,
        fontWeight: '600',
        color: '#5B6773',
        marginRight: 20,
        cursor: 'pointer',
    },
    validityBtn: {
        borderRadius: 6,
        background: 'rgba(130, 78, 210, 0.16)',
        width: 107,
        height: 34,
        color: colors.primary,
        fontSize: 14,
        fontWeight: '600',
        letterSpacing: '-0.1px',
        border: 'none',
        cursor: 'pointer',
    },
    copiedAlertContainer: {
        width: 60,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#282c34',
        color: '#F4F6F8',
        borderRadius: 10,
        position: 'fixed',
        bottom: 15,
        right: 20,
    },
}));

export const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#5B6773',
        color: '#ffffff',
        height: 52,
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 16,
        paddingLeft: 30
    },
    body: {
        fontSize: 14,
        height: 52,
        color: '#5B6773',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: 16,
        paddingLeft: 30,
    },
}))(TableCell);

export const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(even)': {
            backgroundColor: '#F4F6F8',
        },
    },
}))(TableRow);